export default {
  methods: {
    generateRegisterInfo(basic) {
      let reg = {
        did: "",
        id: "",
        idg: "",
        title: "",
        tag: ""
      };
      reg.tag = basic.tag; // tag
      reg.did = basic.did; // basic
      reg.id = basic.id; // basic
      reg.idg = basic.idg; // basic
      reg.title = basic.title; // basic
      reg.tag = basic.tag; // basic
      return reg;
    },
    generateRegisterInfoFacilityListFromUser(info) {
      let reg = {
        did: "",
        id: "",
        idg: "",
        title: "",
        tag: "F1"
      };
      reg.did = info.fdid; // basic
      reg.id = info.fid; // basic
      reg.idg = info.fidg; // basic
      reg.title = info.fname; // basic
      return reg;
    },
    generateRegisterInfoCompanyListFromUser(info) {
      let reg = {
        did: "",
        id: "",
        idg: "",
        title: "",
        tag: "C1"
      };
      reg.did = info.cdid; // basic
      reg.id = info.cid; // basic
      reg.idg = info.cidg; // basic
      reg.title = info.cname; // basic
      return reg;
    },
    generateTreeInfo(basic) {
      let reg = {
        did: "",
        id: "",
        idg: "",
        title: "",
        tag: ""
      };
      reg.tag = basic.tag; // tag
      reg.did = basic.did; // basic
      reg.id = basic.id; // basic
      reg.idg = basic.idg; // basic
      reg.title = basic.title; // basic
      reg.tag = basic.tag; // basic
      return reg;
    },
    generateTreeParentInfo(link) {
      let reg = {
        did: "",
        id: "",
        idg: "",
        title: "",
        tag: ""
      };
      reg.tag = link.atag; // tag
      reg.did = link.adid; // basic
      reg.id = link.aid; // basic
      reg.idg = link.aidg; // basic
      reg.title = link.at; // basic
      return reg;
    }
  }
};
